import * as grid from 'common-ui/lib/common/Components/MuiDataGrid/MuiDataGrid';

export const dataGridTheme = grid.theme;
export const dataGridSx = grid.styleObject;
